import {
  Button,
  Container,
  IconButton,
  LinearProgress,
  makeStyles
} from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import { Page } from 'src/components';
import { PageModuleTitle } from 'src/components/PageModuleTitle';
import AddIcon from '@material-ui/icons/Add';
import { useLocation, useNavigate } from 'react-router';
import useResolution from 'src/hooks/useResolution';
import { TaxCertificateTable } from './components/TaxCertificateTable';
import { Toolbar } from './components/Toolbar';
import { useTaxCertificate } from 'src/hooks/tax-certificate';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { usePermissions } from 'src/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

const BlankIcon: React.ComponentType<SvgIconProps> = () => null;

export const component = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { xs } = useResolution();
  const { canCreate2307Form } = usePermissions();
  const {
    isLoading,
    fetchTaxCertificateList,
    setTaxCertificateListParams,
    taxCertificateList
  } = useTaxCertificate();
  const [alreadyFetched, setAlreadyFetched] = React.useState<boolean>(false);

  const initialParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params: any = {};

    searchParams.forEach((value, key) => {
      if (value === 'undefined' || value === '') {
        params[key] = undefined;
      } else if (!isNaN(Number(value))) {
        params[key] = Number(value);
      } else {
        params[key] = value;
      }
    });

    return params;
  }, [location.search]);

  useEffect(() => {
    setTaxCertificateListParams(initialParams);

    if (
      initialParams &&
      Object.keys(initialParams).length > 0 &&
      !alreadyFetched
    ) {
      fetchTaxCertificateList({ ...initialParams });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialParams]);

  return (
    <Page className={classes.root} title="Tax Certificates">
      <Container maxWidth={false}>
        <PageModuleTitle
          title="Tax Certificates"
          icon={BlankIcon}
          rightContent={
            <>
              {canCreate2307Form ? (
                xs ? (
                  <IconButton
                    color="primary"
                    onClick={() => navigate('/app/tax-certification/add')}
                    size="small"
                    style={{ border: '1px solid currentColor' }}
                  >
                    <AddIcon />
                  </IconButton>
                ) : (
                  <Button
                    color="primary"
                    variant="outlined"
                    startIcon={<AddIcon />}
                    style={{ width: 'fit-content' }}
                    onClick={() => navigate('/app/tax-certification/add')}
                  >
                    Create Form 2307
                  </Button>
                )
              ) : null}
            </>
          }
        />
        <Toolbar onHandleAppliedFilter={() => setAlreadyFetched(true)} />
        {isLoading ? <LinearProgress /> : null}
        {taxCertificateList && taxCertificateList.length > 0 ? (
          <TaxCertificateTable />
        ) : null}
      </Container>
    </Page>
  );
};

export const TaxCertificateList = React.memo(component);
